import { useContext } from "react";
import { AuthenticationContext } from "../auth/authentication-context";

export const useAbilities = () => useContext(AuthenticationContext).abilities;
